<script>
import ExplorerMembers from '@shell/components/ExplorerMembers';
export default { components: { ExplorerMembers } };
</script>

<template>
  <ExplorerMembers v-bind="$attrs" />
</template>
